var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.7L9.3 3L14.7 5.7L20.3727 3.2691C20.4412 3.23975 20.5159 3.22785 20.5901 3.23449C20.6643 3.24112 20.7357 3.26608 20.7979 3.30712C20.8601 3.34816 20.9111 3.404 20.9464 3.46962C20.9816 3.53524 21.0001 3.6086 21 3.6831V18.3L14.7 21L9.3 18.3L3.6273 20.7309C3.55882 20.7603 3.48413 20.7721 3.40992 20.7655C3.33571 20.7589 3.26431 20.7339 3.20213 20.6929C3.13995 20.6518 3.08893 20.596 3.05365 20.5304C3.01837 20.4648 2.99993 20.3914 3 20.3169V5.7ZM15.6 18.6555L19.2 17.1129V5.7297L15.6 7.2723V18.6555ZM13.8 18.5376V7.2624L10.2 5.4624V16.7376L13.8 18.5376ZM8.4 16.7277V5.3445L4.8 6.8871V18.2703L8.4 16.7277Z",
    fill: "#8E53E8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.d2050803350d147c0d59131ee2bef3db.svg";
export { ForwardRef as ReactComponent };